// services/librarianService.js
import { flashMessage } from '../utils/FlashMessage';

const appUrl = process.env.REACT_APP_API_URL;

const getVideosWithLibrarianRatings = async (orgId, accessToken) => {
  console.log('In searchWithQueryRatings:');
  try {
    const response = await fetch(`${appUrl}/api/chain/retrieveVideosWithQueryRatings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ orgId }),
    });

    if (!response.ok) {
      throw new Error(`Error in fetching Lens: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    flashMessage.error(error);
    throw error;
  }
};

export default getVideosWithLibrarianRatings;
